import { configureStore } from "@reduxjs/toolkit";
import MenuState from "./state/MenuState";
import BuyerSellerFilterSlice from "./state/BuyerSellerState";
import DocumentSlice from "./state/DocumentState";
import ExchangeState from "./state/Exchange/ExchangeState";
import MarketMonitoringSlice from "./state/MarketMontitoring/MarketMonitoringState";
import DiscomSlice from "./state/Discom/Discom";
import viewModeReducer from "./state/ViewMode";
import defaultDatesSetterReducer from "./state/DefaultDatesSetter";
import FilterWidthSliceReducer from "./state/FilterWidth";
import demandForecastReducer from "./state/DemandForecast";
import switchTabs from "./state/SwitchTabs";
import disclamerModeleducer from "./state/disclamerModel";
import FilterLoadingStateSliceReducer from "./state/FilterLoadingState";
import BlockSuggestionSliceReducer from "./state/BlockSuggestion";
import modLoadReducer from "./state/ModLoadState";
import modGridcoDateReducer from "./state/ModGridco/ModDate";
import modGridcoSessionReducer from "./state/ModGridco/ModSession";
import modGridcoSessionTokenReducer from "./state/ModGridco/ModSessionToken";
import modGridcoVersionReducer from "./state/ModGridco/ModVersion";
import modDemoDateReducer from "./state/ModDemo/ModDate";
import modDemoSessionReducer from "./state/ModDemo/ModSession";
import modDemoSessionTokenReducer from "./state/ModDemo/ModSessionToken";
import modDemoVersionReducer from "./state/ModDemo/ModVersion";
import modRuvnlDateReducer from "./state/ModRuvnl/ModDate";
import modRuvnlSessionReducer from "./state/ModRuvnl/ModSession";
import modRuvnlSessionTokenReducer from "./state/ModRuvnl/ModSessionToken";
import modRuvnlVersionReducer from "./state/ModRuvnl/ModVersion";
import optimizierReducer from "./state/GNAOptimizer/CurrentOptimisationState";
import OptimizerRuvnlDateReducer from "./state/GNAOptimizer/RuvnlOptimizer/OptimizerDate";
import OptimizerRuvnlSessionReducer from "./state/GNAOptimizer/RuvnlOptimizer/OptimizerSession";
import OptimizerRuvnlSessionTokenReducer from "./state/GNAOptimizer/RuvnlOptimizer/OptimizerSessionToken";
import OptimizerDemoDateReducer from "./state/GNAOptimizer/DemoOptimizer/OptimizerDate";
import OptimizerDemoSessionReducer from "./state/GNAOptimizer/DemoOptimizer/OptimizerSession";
import OptimizerDemoSessionTokenReducer from "./state/GNAOptimizer/DemoOptimizer/OptimizerSessionToken";
import OptimizerGridcoDateReducer from "./state/GNAOptimizer/GridcoOptimizer/OptimizerDate";
import OptimizerGridcoSessionReducer from "./state/GNAOptimizer/GridcoOptimizer/OptimizerSession";
import OptimizerGridcoSessionTokenReducer from "./state/GNAOptimizer/GridcoOptimizer/OptimizerSessionToken";
import ProcurementDemoDateReducer from "./state/ProcurementOptimizer/DemoOptimizer/OptimizerDate";
import ProcurementDemoSessionReducer from "./state/ProcurementOptimizer/DemoOptimizer/OptimizerSession";
import ProcurementDemoSessionTokenReducer from "./state/ProcurementOptimizer/DemoOptimizer/OptimizerSessionToken";
import ProcurementGridcoDateReducer from "./state/ProcurementOptimizer/GridcoOptimizer/OptimizerDate";
import ProcurementGridcoSessionReducer from "./state/ProcurementOptimizer/GridcoOptimizer/OptimizerSession";
import ProcurementGridcoSessionTokenReducer from "./state/ProcurementOptimizer/GridcoOptimizer/OptimizerSessionToken";
import ProcurementRuvnlDateReducer from "./state/ProcurementOptimizer/RuvnlOptimizer/OptimizerDate";
import ProcurementRuvnlSessionReducer from "./state/ProcurementOptimizer/RuvnlOptimizer/OptimizerSession";
import ProcurementRuvnlSessionTokenReducer from "./state/ProcurementOptimizer/RuvnlOptimizer/OptimizerSessionToken";
import SurplusHPPCDateReducer from "./state/SurplusDeficitOptimization/OptimizerDate";
import SurplusHPPCSessionReducer from "./state/SurplusDeficitOptimization/OptimizerSession";
import SurplusHPPCSessionTokenReducer from "./state/SurplusDeficitOptimization/OptimizerSessionToken";
import modCSPDCLDateReducer from "./state/ModCSPDCL/ModDate";
import modCSPDCLSessionReducer from "./state/ModCSPDCL/ModSession";
import modCSPDCLSessionTokenReducer from "./state/ModCSPDCL/ModSessionToken";
import modCSPDCLVersionReducer from "./state/ModCSPDCL/ModVersion";
export const store = configureStore({
  reducer: {
    menu: MenuState,
    buyerSeller: BuyerSellerFilterSlice,
    exchange: ExchangeState,
    document: DocumentSlice,
    marketMonitoring: MarketMonitoringSlice,
    discom: DiscomSlice,
    switchTabs: switchTabs,
    viewMode: viewModeReducer,
    defaultDatesSetter: defaultDatesSetterReducer,
    FilterWidthSlice: FilterWidthSliceReducer,
    demandForecast: demandForecastReducer,
    disclamerModel: disclamerModeleducer,
    FilterLoadingState: FilterLoadingStateSliceReducer,
    BlockSuggestion: BlockSuggestionSliceReducer,
    modGridcoDate: modGridcoDateReducer,
    modGridcoSession: modGridcoSessionReducer,
    modGridcoSessionToken: modGridcoSessionTokenReducer,
    modGridcoVersion: modGridcoVersionReducer,
    modLoad: modLoadReducer,
    modDemoDate: modDemoDateReducer,
    modDemoSession: modDemoSessionReducer,
    modDemoSessionToken: modDemoSessionTokenReducer,
    modDemoVersion: modDemoVersionReducer,
    modRuvnlDate: modRuvnlDateReducer,
    modRuvnlSession: modRuvnlSessionReducer,
    modRuvnlSessionToken: modRuvnlSessionTokenReducer,
    modRuvnlVersion: modRuvnlVersionReducer,
    optimizierData: optimizierReducer,
    OptimizerRuvnlDate: OptimizerRuvnlDateReducer,
    OptimizerRuvnlSession: OptimizerRuvnlSessionReducer,
    OptimizerRuvnlSessionToken: OptimizerRuvnlSessionTokenReducer,
    OptimizerDemoDate: OptimizerDemoDateReducer,
    OptimizerDemoSession: OptimizerDemoSessionReducer,
    OptimizerDemoSessionToken: OptimizerDemoSessionTokenReducer,
    OptimizerGridcoDate: OptimizerGridcoDateReducer,
    OptimizerGridcoSession: OptimizerGridcoSessionReducer,
    OptimizerGridcoSessionToken: OptimizerGridcoSessionTokenReducer,
    ProcurementOptimizerDemoDate: ProcurementDemoDateReducer,
    ProcurementOptimizerDemoSession: ProcurementDemoSessionReducer,
    ProcurementOptimizerDemoSessionToken: ProcurementDemoSessionTokenReducer,
    ProcurementOptimizerGridcoDate: ProcurementGridcoDateReducer,
    ProcurementOptimizerGridcoSession: ProcurementGridcoSessionReducer,
    ProcurementOptimizerGridcoSessionToken:
      ProcurementGridcoSessionTokenReducer,
    ProcurementOptimizerRuvnlDate: ProcurementRuvnlDateReducer,
    ProcurementOptimizerRuvnlSession: ProcurementRuvnlSessionReducer,
    ProcurementOptimizerRuvnlSessionToken: ProcurementRuvnlSessionTokenReducer,
    SurplusOptimizerHPPCDate: SurplusHPPCDateReducer,
    SurplusOptimizerHPPCSession: SurplusHPPCSessionReducer,
    SurplusOptimizerHPPCSessionToken: ProcurementDemoSessionTokenReducer,
    modCSPDCLDate: modCSPDCLDateReducer,
    modCSPDCLSession: modCSPDCLSessionReducer,
    modCSPDCLSessionToken: modCSPDCLSessionTokenReducer,
    modCSPDCLVersion: modCSPDCLVersionReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
